import Vue from 'vue';
import { client } from '@/store';

export default {
	namespaced: true,

	state: {
		mapType: null,
		markers: [],
		trackings: [],
		viewingUserId: null,
		marketingReviewPlatform: "google"
	},

	// sync actions
	mutations: {
		setMarkers(state, value) {
			// state.markers = value;
			Vue.set(state, 'markers', [...value]);
		},

		updateMarker(state, value) {
			state.markers = [
				...state.markers.filter(item => item.id !== value.id),
				value.marker
			];
		},

		setViewingUserId(state, value) {
			state.viewingUserId = value;
		},

		setTrackings(state, value) {
			state.trackings = value;
		},

		setMapType(state, value) {
			state.mapType = value;
		},

		setMarketingReviewPlatform(state, value) {
			state.marketingReviewPlatform = value;
		}
	},

	// async actions
	actions: {
		fetchAdditionalMarkerInfo({ commit, state, dispatch }, data) {
			const query = `
			query ($id: Int) {
				company(id: $id) {
					email
					customfield_afspraakdatum
					customfield_afspraaktijdstip
					customfield_afspraakwoningtype
					customfield_leadkanaal
					customfield_kmkmedewerker
					customfield_dmbron
					customfield_laatstgebeldmarketing
					createdon
					kmkReferer {
						id
						companyname
					}
					invoices {
						id
						number
						invoicelines {
							product
						}
					}
					projects {
						id
						name
						number
						enddate
						deliverydate,
						appointments {
							id
						}
					}
					agent { display_name }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					resolve(result.company);
				});
			});
		},

		fetchAdditionalCompanyData({ commit, state, dispatch }, data) {
			const query = `
			query ($id: Int) {
				company(id: $id) {
					customfield_afspraakisolatie
					customfield_afspraakbouwjaar
					customfield_afspraakwoningtype
					customfield_afspraakbuitenmuren
					customfield_afspraakhoogtekruipruimte
					customfield_afspraakkruipruimtedroog
					customfield_afspraakkruipruimtetoegankelijk
					customfield_afspraakvloerverwarming
					customfield_afspraakplanner
					customfield_leadkanaal
					customfield_plannerid
					customfield_afspraakdatum
					customfield_afspraaktijdstip
					customfield_afspraakingepland
					customfield_planningafwijzing
					customfield_zakelijkeleads
					customfield_kmkmedewerker
					customfield_kmk
					customfield_terugkoppeling
					customfield_klantaanwezig
					customfield_leeftijdklant
					customfield_directverkocht
					customfield_verkochteproducten
					customfield_verkoopbedrag
					customfield_subsidie
					customfield_datumaantafel
					customfield_vloergeinspecteerd
					customfield_technischnietmogelijk
					customfield_redennietverkocht
					customfield_opmerkingafspraak
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					resolve(result.company);
				});
			});
		},

		fetchMapMarkers({ commit, state, dispatch }, data) {
			const markersQuery = `
			query ($filter: String, $afterDate: String, $search: String, $historicFromDate: String, $historicTillDate: String, $agentFilter: Int) {
				planningMarkers(filter: $filter, afterDate: $afterDate, search: $search, historicFromDate: $historicFromDate, historicTillDate: $historicTillDate, agentFilter: $agentFilter) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					notes
					gripp_accountmanager_id
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(markersQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setMarkers', result.planningMarkers);
					resolve(result.planningMarkers);
				});
			});
		},

		fetchAppointmentMarkers({ commit, state, dispatch }, data) {
			const markersQuery = `
			query ($filter: String, $type: String, $afterDate: String, $search: String, $historicFromDate: String, $historicTillDate: String, $agentFilter: [Int]) {
				appointmentMarkers(filter: $filter, type: $type, afterDate: $afterDate, search: $search, historicFromDate: $historicFromDate, historicTillDate: $historicTillDate, agentFilter: $agentFilter) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					notes
					gripp_accountmanager_id
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(markersQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setMarkers', result.appointmentMarkers);
					resolve(result.appointmentMarkers);
				});
			});
		},

		performAction({ commit, state, dispatch }, data) {
			const query = `
			query ($type: String, $company_id: Int, $user_id: Int) {
				marker: performAction(type: $type, company_id: $company_id, user_id: $user_id) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateMarker', {
						id: result.marker.id,
						marker: result.marker
					});
					resolve(result.marker);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		performActionReview({ commit, state, dispatch }, data) {
			const query = `
			query ($type: String, $company_id: Int, $user_id: Int, $marketing_review_platform: String) {
				marker: performAction(type: $type, company_id: $company_id, user_id: $user_id, marketing_review_platform: $marketing_review_platform) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateMarker', {
						id: result.marker.id,
						marker: result.marker
					});
					resolve(result.marker);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		createNote({ commit, state, dispatch }, data) {
			const query = `
			query ($company_id: Int, $type: String, $text: String, $project_id: Int) {
				marker: createNote(company_id: $company_id, note_type: $type, text: $text, project_id: $project_id) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					tags { name }
					lastTimeline { id, date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateMarker', {
						id: result.marker.id,
						marker: result.marker
					});
					resolve(result.marker);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		createAppointment({ commit, state, dispatch }, data) {
			const query = `
			query ($company_id: Int, $agent_id: Int, $planner_id: Int, $salutation: Int, $initials: String, $infix: String, $lastname: String, $street: String, $streetnumber: String, $postalcode: String, $city: String, $email: String, $isolation_type: String, $building_construction_date: String, $building_type: String, $building_walls: String, $crawlspace_height: String, $crawlspace_dry: String, $crawlspace_accessible: String, $floor_heating: String, $notes: String, $date: String, $lat: String, $lng: String, $sendMail: Boolean) {
				marker: createAppointment(company_id: $company_id, agent_id: $agent_id, planner_id: $planner_id, salutation: $salutation, initials: $initials, infix: $infix, lastname: $lastname, street: $street, streetnumber: $streetnumber, postalcode: $postalcode, city: $city, email: $email, isolation_type: $isolation_type, building_construction_date: $building_construction_date, building_type: $building_type, building_walls: $building_walls, crawlspace_height: $crawlspace_height, crawlspace_dry: $crawlspace_dry, crawlspace_accessible: $crawlspace_accessible, floor_heating: $floor_heating, notes: $notes, date: $date, lat: $lat, lng: $lng, sendMail: $sendMail) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateMarker', {
						id: result.marker.id,
						marker: result.marker
					});
					resolve(result.marker);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		reassignAppointment({ commit, state, dispatch }, data) {
			const query = `
			query ($company_id: Int, $agent_id: Int) {
				marker: reassignAppointment(company_id: $company_id, agent_id: $agent_id) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateMarker', {
						id: result.marker.id,
						marker: result.marker
					});
					resolve(result.marker);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		cancelAppointment({ commit, state, dispatch }, data) {
			const query = `
			query ($company_id: Int, $reschedule: Boolean) {
				marker: cancelAppointment(company_id: $company_id, reschedule: $reschedule) {
					id
					companyname
					salutation
					initials
					infix
					lastname
					mobile
					phone
					email
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_zipcode
					visitingaddress_city
					coordinates
					color
					tags { name }
					lastTimeline { date, message }
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateMarker', {
						id: result.marker.id,
						marker: result.marker
					});
					resolve(result.marker);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		fetchTrackings({ commit, state, dispatch }, data) {
			const query = `
			query {
				trackings {
					id
					trackingnr
					speed
					coordinates
				}
			}`;

			return new Promise((resolve, reject) => {
				client.query(query, { ...data }).then(result => {
					commit('setTrackings', result.trackings);
					resolve(result.trackings);
				});
			});
		},

		createCompany({ commit, state, dispatch }, data) {
			const query = `
			mutation ($postal_code: String!, $street_number: String!, $street_name: String!, $city: String!, $municipality: String!, $province: String!, $latitude: String!, $longitude: String!, $initial: String, $insertion: String!, $last_name: String!, $phone_number: String!, $email: String!, $dmBron: String!, $direct_mailing: String, $housingType: String, $buildYear: String, $kmkEmployee: String, $kmk: String, $shouldSendConfirmation: Boolean) {
				company: createCompany(postal_code: $postal_code, street_number: $street_number, street_name: $street_name, city: $city, municipality: $municipality, province: $province, latitude: $latitude, longitude: $longitude, initial: $initial, insertion: $insertion, last_name: $last_name, phone_number: $phone_number, email: $email, dmBron: $dmBron, direct_mailing: $direct_mailing, housingType: $housingType, buildYear: $buildYear, kmkEmployee: $kmkEmployee, kmk: $kmk, shouldSendConfirmation: $shouldSendConfirmation) {
					id
				}
			}`;

			return new Promise((resolve, reject) => {
				client.query(query, { ...data }).then(result => {
					if(result.errors != null && result.errors.length > 0) {
						reject(result.errors);
						return;
					}
					resolve(result);
				}).catch((error) => {
					reject(error);
				});
			});
		},
		setLoading({ commit, state, dispatch }) {
			commit('setLoading', null, { root: true });
		},
		setIdle({ commit, state, dispatch }) {
			commit('setIdle', null, { root: true });
		}
	}
};
